
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";

// Create a new query client with retry disabled to prevent infinite loading loops
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

// Function to remove badge elements
const removeBadgeElements = () => {
  // Remove any existing badge
  const badgeElement = document.getElementById('lovable-badge');
  if (badgeElement) {
    badgeElement.remove();
  }
  
  // Create a MutationObserver to remove any dynamically added badges
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            const element = node as Element;
            if (element.id === 'lovable-badge') {
              element.remove();
            }
          }
        });
      }
    });
  });

  // Start observing the document body for added nodes
  observer.observe(document.body, { childList: true, subtree: true });
  
  return () => observer.disconnect();
};

const BadgeRemover = () => {
  useEffect(() => {
    return removeBadgeElements();
  }, []);
  
  return null;
};

// App initialization with console logging for debugging
const App = () => {
  useEffect(() => {
    console.log("App initialized");
    window.onerror = function(message, source, lineno, colno, error) {
      console.error("Global error caught:", { message, source, lineno, colno, error });
      return false;
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BadgeRemover />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
